<template>
  <a-card class="auth__card" title="Регистрация">
    <a-form>
      <a-form-item label="Ваше имя">
        <a-input v-model="params.name" placeholder="Иван"></a-input>
      </a-form-item>
      <a-form-item label="Ваш email">
        <a-input
          v-model="params.email"
          type="email"
          placeholder="user@mail.com"
        ></a-input>
      </a-form-item>
      <a-form-item label="Пароль">
        <a-input
          v-model="params.password"
          type="password"
          placeholder="********"
        ></a-input>
      </a-form-item>
      <a-form-item label="Повторите пароль">
        <a-input
          v-model="params.password2"
          type="password"
          placeholder="********"
        ></a-input>
      </a-form-item>
      <a-form-item>
        <a-button
          @click="reg"
          :loading="isLoading"
          class="button"
          block
          type="primary"
          html-type="submit"
          >Зарегистрироваться</a-button
        >
      </a-form-item>
      <p>
        <router-link to="/auth/login">Назад</router-link>
      </p>
    </a-form>
  </a-card>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      params: {
        name: '',
        email: '',
        password: '',
        password2: '',
      },
    };
  },
  methods: {
    reg() {
      this.isLoading = true;
      this.$api.register({
        ...this.params,
      }).then((response) => {
        this.$store.commit('setToken', response.data.access_token);
        this.$router.push('/');
      }).finally(() => {
        this.isLoading = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.text-center {
  text-align: center;
}
</style>
